<template>
  <div
    class="container"
    :data-action="dataAction"
    :data-listname="dataListname"
    :data-assettype="dataAssettype"
    :data-assetname="dataAssetname"
    @click="action(query)"
  >
    <div class="container__content">
      <div class="container__content--name">{{ fullName }}</div>
      <div class="container__content--date">
        <i class="fal fa-clock"></i>
        {{ getDateFormat(createdDate, createdTime) }}
        <i class="fas fa-chevron-right chevron"></i>
      </div>
      <div class="container__content--buy">
        <div class="title">{{ buyTitle }}</div>
        <div class="price">{{ getNumberFormat(buyPrice) }}</div>
      </div>
      <div class="container__content--sell">
        <div class="title">{{ sellTitle }}</div>
        <div class="price">{{ getNumberFormat(sellPrice) }}</div>
      </div>
      <div v-if="changePrice" class="container__content--change">
        <div v-if="item.name === 'spot'" class="title">% Chg.</div>
        <i v-if="item.name !== 'spot'" :class="[getPriceIcon(changePrice), getClassPercent(changePrice)]"></i>
        <span class="price" :class="getClassPercent(changePrice)">{{ getChangeFormat(changePrice) | minusValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { timestampToDate, calPercentChange } from '../../../utils/global'

export default {
  props: {
    item: {
      type: Object,
      default: function() {
        return []
      }
    },
    action: {
      type: Function
    },
    query: {
      type: Object
    },
    dataAction: {
      type: String,
      default: null
    },
    dataListname: {
      type: String,
      default: null
    },
    dataAssettype: {
      type: String,
      default: null
    },
    dataAssetname: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      objPeriod: {
        '1D': '1 Day',
        '1W': '1 Week',
        '1M': '1 Month',
        '3M': '3 Months',
        '6M': '6 Months',
        '1Y': '1 Year',
        '3Y': '3 Years',
        '5Y': '5 Years',
        '10Y': '10 Years'
      }
    }
  },
  filters: {
    minusValue(val) {
      if (val < 0) {
        return parseFloat(val.replace('-', ''))
      }
      return val
    }
  },
  computed: {
    ...mapGetters('gold', ['getGoldTraderPresent', 'getGoldSpotPreviousClose']),
    buyTitle() {
      switch (this.item.name) {
        case 'spot':
          return 'ราคาเปิด'
        default:
          return 'รับซื้อ'
      }
    },
    sellTitle() {
      switch (this.item.name) {
        case 'spot':
          return 'ราคาปิด'
        default:
          return 'ขายออก'
      }
    },
    fullName() {
      switch (this.item.name) {
        case 'bar':
          return 'ทองคำแท่ง 96.5%'
        case 'ornament':
          return 'ทองรูปรรณ 96.5%'
        case 'spot':
          return 'Gold Spot'
        default:
          return ''
      }
    },
    createdDate() {
      return this.getGoldTraderPresent.data ? `${this.getGoldTraderPresent.data.createdAt}` : ''
    },
    createdTime() {
      if (this.getGoldTraderPresent.data) {
        switch (this.item.name) {
          default:
            return `ครั้งที่ ${this.getGoldTraderPresent.data.createdTime}`
        }
      } else return ''
    },
    buyPrice() {
      switch (this.item.name) {
        case 'bar':
          return this.getGoldTraderPresent.data ? this.getGoldTraderPresent.data.barBuyPrice : ''
        case 'ornament':
          return this.getGoldTraderPresent.data ? this.getGoldTraderPresent.data.ornamentBuyPrice : ''
        case 'spot':
          return this.getGoldSpotPreviousClose ? this.getGoldSpotPreviousClose.o : ''
        default:
          return ''
      }
    },
    sellPrice() {
      if (this.getGoldTraderPresent.data) {
        switch (this.item.name) {
          case 'bar':
            return this.getGoldTraderPresent.data ? this.getGoldTraderPresent.data.barSellPrice : ''
          case 'ornament':
            return this.getGoldTraderPresent.data ? this.getGoldTraderPresent.data.ornamentSellPrice : ''
          case 'spot':
            return this.getGoldSpotPreviousClose ? this.getGoldSpotPreviousClose.c : ''
          default:
            return ''
        }
      } else return ''
    },
    changePrice() {
      switch (this.item.name) {
        case 'bar':
          return this.getGoldTraderPresent.data ? this.getGoldTraderPresent.data.barPriceChange : ''
        case 'ornament':
          return ''
        case 'spot':
          return this.getGoldSpotPreviousClose
            ? calPercentChange(this.getGoldSpotPreviousClose.o, this.getGoldSpotPreviousClose.c, 2)
            : ''
        default:
          return ''
      }
    }
  },
  methods: {
    formatDate(timestamp) {
      return moment(timestamp).format('DD/MM/YY')
    },
    getClassPercent(val) {
      if (!val) return 'null-percent'
      switch (true) {
        case val > 0:
          return 'plus'
        case val < 0:
          return 'minus'
        default:
          return 'normal'
      }
    },
    getNumberFormat(num) {
      let unit = this.item.name === 'spot' ? '$' : '฿'
      let toNumber = parseFloat(num)
      if (isNaN(toNumber)) {
        return '0.00'
      }
      return `${toNumber
        .toLocaleString('th', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${unit}`
    },
    getPriceIcon(price) {
      if (price > 0) {
        return 'fas fa-caret-up'
      } else if (price == 0) {
        return 'fas fa-sort'
      } else return 'fas fa-caret-down'
    },
    getChangeFormat(change) {
      if (this.item.name === 'spot') return `${change} %`
      return change
    },
    getDateFormat(createdDate, createdTime) {
      if (this.item.name === 'spot') {
        return timestampToDate(this.getGoldSpotPreviousClose.t, 'DD/MM/YY | HH:mm', 'global')
      }
      return `${timestampToDate(createdDate, 'DD/MM/YY', 'global')} | ${createdTime}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/_BoxAsset';
</style>